import styled from 'styled-components';

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
  flex-direction: column;
  row-gap: 30px;
  background: linear-gradient(
    135deg,
    #eff2f7 0%,
    rgba(23, 122, 251, 0.35) 100%
  );
`;

export const LoadingMainMessage = styled.span`
  font-family: 'Nunito', sans-serif;
  font-size: 28px;
  max-width: 500px;
  text-align: center;
  font-weight: 700;
`;
